import React, {useEffect, useState} from "react";
import SVG from "react-inlinesvg";
import SimpleTable from "my-simple-react-table";
import TableSkeleton from "../../../../../../../util/TableSkeleton";
import { toAbsoluteUrl } from "../../../../../../../../_metronic/_helpers";
import * as handlers from "../../../../../_redux/selected-user/selectedUserHandlers";
import { useSelector, shallowEqual, useDispatch } from "react-redux"
import {formatDate, formatStatus, permissionCssClass} from "../../../../../../../util/Helpers";
import ViewBankAccountModal from "./modal/ViewBankAccountModal";
import AddBankAccountModal from "./modal/AddBankAccountModal";
import DeleteBankAccountModal from "./modal/DeleteBankAccountModal";
import { Permissions, PermissionType } from "../../../../../../../util/Permissions";

const BankAccounts = props => {

    const adminUser = useSelector(state => state.auth.user);
    /* Get User Bank Accounts from redux */
    const [bankAccounts, notification] = useSelector(({selectedUser}) => [selectedUser.data?.bankAccounts, selectedUser.notification], shallowEqual);
    /* Bank Account Modal State Management */
    const [bankAccountModal, setBankAccountModal] = useState({showAddBankAccountModal: false, showViewBankAccountModal: false, showDeleteBankAccountModal: false, details: null});

    // Redux dispatch
    const dispatch = useDispatch();

    /* Fetch User Bank Account on success notification */
    useEffect(() => {
        if (notification?.message === "User Bank Account Added" || notification?.message === "User Bank Account Deleted"){
            dispatch(handlers.fetchUserBankAccounts(props.match.params.userId));
        }
    }, [dispatch, notification, props.match.params.userId]);

    /* Fetch User Bank Account */
    useEffect(() => {
        dispatch(handlers.fetchUserBankAccounts(props.match.params.userId));
    }, [dispatch, props.match.params.userId]);

    /* Modal show/hide Toggle */
    const toggleModal = modal => _ => {
        setBankAccountModal({...bankAccountModal, [modal]: !bankAccountModal[modal] })
    }

    const formatBankAccount = row => {
        return <div className="d-flex align-items-center" style={{ whiteSpace: "nowrap" }}>
            <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                <SVG
                    title=""
                    src={toAbsoluteUrl("/media/svg/icons/Shopping/Money.svg")}
                />
            </span>
            <div>
                <span className="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">
                    {row.bankName}
                    <span className="text-muted pl-2">
                        {row.accountNumber} - {row.currency}
                    </span>
                </span>
            </div>
        </div>
    }

    // Action Buttons
    const actionButton = row => {

        return <span style={{ whiteSpace: "nowrap" }}>
            <button
                className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                onClick={_ => viewBankAccountDetails(row.ref)}
            >
                <span className="svg-icon svg-icon-md svg-icon-primary">
                    <SVG
                        title="View Bank Account"
                        src={toAbsoluteUrl("/media/svg/icons/General/Eye-2.svg")}
                    />
                </span>
            </button>

            <button
                className={`btn btn-icon btn-light btn-hover-danger btn-sm ${permissionCssClass(adminUser, Permissions.BANK_ACCOUNTS, PermissionType.DELETE)}`}
                onClick={_ => deleteBankAccount(row.ref)}
            >
                <span className="svg-icon svg-icon-md svg-icon-danger">
                    <SVG
                        title="Delete Bank Account"
                        src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
                    />
                </span>
            </button>
        </span>
    }

    // View Bank Account Details
    const viewBankAccountDetails = ref => {
        const details = bankAccounts.filter(bankAccount => ref === bankAccount.ref)[0];
        setBankAccountModal({...bankAccountModal, showViewBankAccountModal: true, details});
    }

    // Delete Bank Account
    const deleteBankAccount = ref => {
        const details = bankAccounts.filter(bankAccount => ref === bankAccount.ref)[0];
        setBankAccountModal({...bankAccountModal, showDeleteBankAccountModal: true, details});
    }

    return <div className="card card-custom gutter-b">
        <div className="row">
            <div className="col-12">
                {/* <!--begin::List Widget 14--> */}
                <div className="card card-custom gutter-b">
                    {/* <!--begin::Header--> */}
                    <div className="card-header border-0">
                        {/* <!--begin::Title--> */}
                        <div className="card-title pt-5 w-100">
                            <h3 className="card-label">
                                <span className="d-block text-dark h3 font-weight-bolder">Bank Accounts</span>
                                <span className="d-block text-muted mt-2 font-size-sm">User Withdrawal Bank Account</span>
                            </h3>
                            <div className={`card-toolbar ml-auto ${permissionCssClass(adminUser, Permissions.BANK_ACCOUNTS, PermissionType.CREATE)}`}>
                                <button
                                    className="btn btn-primary font-weight-bolder font-size-sm"
                                    onClick={toggleModal("showAddBankAccountModal")}
                                >
                                    <span className="svg-icon svg-icon-md svg-icon-white">
                                        <SVG
                                            title=" "
                                            src={toAbsoluteUrl("/media/svg/icons/Code/Plus.svg")}
                                        />
                                    </span>
                                    Add Bank Account
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* <!--end::Header--> */}
                    {/* <!--begin::Body--> */}
                    <div className="card-body pt-0 ">
                        {
                            bankAccounts ? (
                                <div className={permissionCssClass(adminUser, Permissions.BANK_ACCOUNTS, PermissionType.READ)}>
                                    <SimpleTable
                                        data={bankAccounts}
                                        columns={[
                                            { title: "BANK ACCOUNT", format: formatBankAccount },
                                            { title: "STATUS", format: row => formatStatus(row.status) },
                                            { title: "DATE", format: row => formatDate(row.createdAt) },
                                            { title: "", format: actionButton }
                                        ]}
                                    />
                                </div>
                            ) : (
                                <TableSkeleton />
                            )
                        }
                    </div>

                    {/* <!--end::Body--> */}
                </div>
                {/* <!--end::List Widget 14--> */}
            </div>
        </div>
        <ViewBankAccountModal {...bankAccountModal} onHide={toggleModal("showViewBankAccountModal")} />
        <DeleteBankAccountModal {...bankAccountModal} onHide={toggleModal("showDeleteBankAccountModal")} />
        <AddBankAccountModal {...bankAccountModal} {...props} onHide={toggleModal("showAddBankAccountModal")} />

    </div>

}

export default BankAccounts;